var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadysetIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 26.7C10.5 24.8 8.39997 20.4 9.49997 16C4.79997 13.4 2.19996 8.2 2.79996 2.8C8.19996 2.2 13.4 4.8 16 9.5C20.4 8.4 24.9 10.5 26.7 14.5C18.3 11.5 11.6 18.3 14.5 26.7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 26.7C10.5 24.8 8.39997 20.4 9.49997 16C4.79997 13.4 2.19996 8.2 2.79996 2.8C8.19996 2.2 13.4 4.8 16 9.5C20.4 8.4 24.9 10.5 26.7 14.5C18.3 11.5 11.6 18.3 14.5 26.7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7 25.6C24.2 25.4 21.6 24.9 19.7 23.8C13.8 20.3 20.4 13.7 23.9 19.6C25 21.4 25.5 24.1 25.7 25.6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 0H14L19.3 5.3H35.5C42.4 5.3 48.1 10.9 48.1 17.9V19.8C48.1 23.9 46.1 27.7 42.7 30.1L41.8 30.7L45.6 34.5L46.2 34C50.7 30.6 53.3 25.4 53.3 19.8V17.9C53.4 8 45.4 0 35.5 0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6 48.8L29.8 26L26.1 29.7L44.4 48H18.5C11.3 48 5.39997 42.1 5.39997 34.9V19.2L0.0999756 13.9V34.9C0.0999756 45 8.39997 53.3 18.5 53.3H50.8C51.9 53.3 52.8 52.7 53.2 51.7C53.6 50.7 53.4 49.5 52.6 48.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadysetIconWhite);
export default __webpack_public_path__ + "static/media/readyset-icon-white.138a6d4556db2cebed66d5cbc40379ee.svg";
export { ForwardRef as ReactComponent };